(function () {
  function refreshProductCardImageSliders() {
    if (typeof Flickity === "undefined") return;

    document
      .querySelectorAll(".js-product-card-image-slider")
      .forEach((slider) => {
        const flkty = Flickity.data(slider);

        if (flkty) {
          flkty.destroy();
        }

        slider.removeAttribute("style");

        slider
          .querySelectorAll(".product-card__image-slide")
          .forEach((slide) => {
            slide.removeAttribute("style");
          });
      });

    setTimeout(() => {
      if (typeof window.initProductCardImageSliders === "function") {
        window.initProductCardImageSliders();
      }
    }, 50);
  }

  function containerUpdate(container, cardSize) {
    container.setAttribute("data-catalog-card-size", cardSize);
    container.setAttribute("data-switching", true);

    setTimeout(() => {
      container.removeAttribute("data-switching");
      refreshProductCardImageSliders();
    }, 350);
  }

  function switchCardSize() {
    const buttons = document.querySelectorAll(".js-switch-card-size");
    const pageHeader = document.querySelector("sticky-header.header-wrapper");
    let headerRevealTimeout = null;
    let currentAbortController = null;

    const handleButtonEvent = (button) => {
      const cardSize = button.dataset.cardSize;

      buttons.forEach((btn) => btn.classList.remove("active-layout"));
      button.classList.add("active-layout");

      document.querySelectorAll("[data-catalog-card-size]").forEach((el) => {
        containerUpdate(el, cardSize);
      });

      requestAnimationFrame(() => {
        refreshProductCardImageSliders();
      });

      setTimeout(refreshProductCardImageSliders, 100);
      setTimeout(refreshProductCardImageSliders, 400);

      if (pageHeader) {
        if (headerRevealTimeout) clearTimeout(headerRevealTimeout);
        pageHeader.preventReveal = true;
      }

      if (currentAbortController) currentAbortController.abort();
      currentAbortController = new AbortController();

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "catalog-card-size": cardSize,
          },
        }),
        signal: currentAbortController.signal,
      })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.error("Request error:", error);
          }
        })
        .finally(() => {
          if (pageHeader) {
            headerRevealTimeout = setTimeout(() => {
              pageHeader.preventReveal = false;
            }, 400);
          }
        });
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => handleButtonEvent(button));

      button.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleButtonEvent(button);
        }
      });
    });
  }

  switchCardSize();

  document.addEventListener("shopify:section:load", function () {
    switchCardSize();
    setTimeout(refreshProductCardImageSliders, 100);
  });
})();
